module.exports = __webpack_public_path__ + "img/password.ef02aab6.svg";